module.exports = __webpack_public_path__ + "R6E_DELUXE_1920x1080_KR.jpg";